import { createFileRoute } from '@tanstack/react-router';
import { UserProfileContent } from './p.$id';

export const Route = createFileRoute('/p/$id/folder/$folderId/$slug/$page')({
  component: PublicFolderPageRoute,
});

function parsePageParam(rawPage: string | undefined): number {
  const parsed = Number(rawPage);
  if (!Number.isFinite(parsed) || parsed < 1) return 1;
  return Math.floor(parsed);
}

function PublicFolderPageRoute() {
  const { id: userId, folderId, slug, page: pageParam } = Route.useParams();
  const page = parsePageParam(pageParam);
  return (
    <UserProfileContent
      userId={userId}
      page={page}
      folderId={folderId}
      folderSlug={slug}
    />
  );
}
